import React from 'react';
import styled, { ThemeProps } from 'styled-components';
import { colors } from 'styleguide/colors';
import { View } from 'styleguide/View';
import { Theme } from 'styleguide/types';
import { getSupersetColor } from 'styleguide/colors';
import { Spacing } from 'styleguide/spacing';
import { SupersetChicklet } from 'components/SupersetChicklet';
import { ExerciseCard } from './ExerciseCard';
import { ExerciseSummaryExercise } from './types';

const Container = styled.div`
  display: flex;
  flex: 1;
`;

const SupersetContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const SupersetExerciseContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 0px 4px 4px 0px;
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'light' ? colors.greyHiperLight : colors.blackLight};
`;

interface SupersetGroupCellProps {
  supersetId?: number;
  exercises: ExerciseSummaryExercise[];
  showDivider: boolean;
}

export const SupersetGroupCell = ({ supersetId, exercises }: SupersetGroupCellProps) => {
  return (
    <Container>
      {supersetId === undefined ? (
        exercises.map(e => (
          <ExerciseCard
            key={e.title}
            title={e.title}
            notes={e.notes}
            image={e.image}
            sets={e.sets}
            reps={e.reps}
            timer={e.timer}
          />
        ))
      ) : (
        <SupersetContainer>
          <View style={{ flexDirection: 'row', marginTop: Spacing.sm }}>
            <SupersetChicklet id={supersetId} />
          </View>
          <View style={{ flexDirection: 'row', flex: 1, marginTop: Spacing.sm }}>
            <SupersetExerciseContainer>
              {exercises.map(e => (
                <ExerciseCard
                  key={e.title}
                  title={e.title}
                  notes={e.notes}
                  image={e.image}
                  sets={e.sets}
                  reps={e.reps}
                  timer={e.timer}
                  supersetColor={getSupersetColor(supersetId)}
                />
              ))}
            </SupersetExerciseContainer>
          </View>
        </SupersetContainer>
      )}
    </Container>
  );
};
